import { ListingFilter } from '@/types';

export const getSelectOptionLabel = (filter: ListingFilter) =>
  filter.count >= 0 ? `${filter.label} (${filter.count})` : filter.label;
